import { render, staticRenderFns } from "./fxCont.vue?vue&type=template&id=0a0cca69&scoped=true&"
import script from "./fxCont.vue?vue&type=script&lang=js&"
export * from "./fxCont.vue?vue&type=script&lang=js&"
import style0 from "./fxCont.vue?vue&type=style&index=0&id=0a0cca69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cca69",
  null
  
)

export default component.exports